export default {
    namespaced: true,
    actions: {
        set({ commit }, params) {
            localStorage.setItem('prontro-atendimento-fila', JSON.stringify(params))
            commit('set', params)
        },
    },
    getters: {
        get(state) {
            return state
        },
    },
    mutations: {
        set(state, params) {
            state = params
        },
    },
    state: JSON.parse(localStorage.getItem('prontro-atendimento-fila')),
}